import React from 'react';
import { useGlobalBridge } from "./useGlobalBridge";
export var useNodeRectAfterSync = function useNodeRectAfterSync() {
  var globalBridge = useGlobalBridge();
  React.useEffect(function () {
    globalBridge.nodeRectObserver.updateNodeRect();
  }, [globalBridge]);
};